import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Old /results-old/<name>/ pages (18 referring domains on urlacher). WordPress
// sent urlacher to /results/brian-urlacher/.
const TARGETS: Record<string, string> = {
  urlacher: "/results/brian-urlacher/",
  "bryan-bickell": "/results/bryan-bickell/",
};

export const Route = createFileRoute("/results-old/$")({
  beforeLoad: ({ params, location }) => {
    const name = (params._splat ?? "").replace(/^\/+|\/+$/g, "");
    throw redirect({ href: withQuery(TARGETS[name] ?? "/results/", location.searchStr), statusCode: 301 });
  },
});
